-- | What the coverage recommendation says about each cell of the conjugation
-- | table. The recommendation is generated into
-- | `Flashcards.Data.Coverage.Spanish` from `data/es-verb-coverage.csv`, which
-- | is itself generated by `tools/verb-coverage.mjs`; this is where its types
-- | live, since a generated module cannot be where they are defined.
-- |
-- | The verdict and not the reasoning: the CSV's `Why` column is for a person
-- | arguing with #27, and stays there. See #96.
module Flashcards.Verbs.Coverage
  ( Recommend(..)
  , Verdict
  )
  where

import Prelude

import Flashcards.Verbs.Table (Person, Tense)

-- | Three, not two. `Later` is a cell worth drilling on a verb the deck
-- | does not teach or teaches past rank 500; `Skip` is a cell the ending
-- | rule already covers. Whether a view tells them apart is its own
-- | decision, so they are not folded together here.
data Recommend
  = Drill
  | Later
  | Skip

derive instance Eq Recommend
derive instance Ord Recommend

instance Show Recommend where
  show Drill = "Drill"
  show Later = "Later"
  show Skip = "Skip"

-- | One cell's recommendation. Per cell rather than per verb and tense, so
-- | that whether persons show is left to whatever reads it.
type Verdict =
  { infinitive :: String
  , tense :: Tense
  , person :: Person
  , recommend :: Recommend
  }
